
import {
    Col,
    FormGroup,
    Modal,
    ModalBody,
    Label,
    Input
} from "reactstrap";
import PreventEnterSubmitForm from "../../components/Forms/PreventEnterSubmitForm";
import ActionModalHeader from "../../components/ActionModalHeader/ActionModalHeader";
import Button from "../../components/UIButton/UIButton";
import Spinner from "../../components/UISpinner/UISpinner";

export default function CreateEditOrganizationModal({ isCreate, isOpen, onSave, onCancel, suborgData, hasError, errorMessage, isLoading }) {

    const headerText = isCreate ? "Create Organization" : "Edit Organization";

    const saveOrUpdateBtn = (
        <Button
            variant="submit"
            size="medium"
            disabled={isLoading}
        >Save Changes</Button>
    );

    return (
        <Modal size="md" isOpen={isOpen}>
            <PreventEnterSubmitForm onSubmit={onSave}>
                <ActionModalHeader
                    title={headerText}
                    onCancel={onCancel}
                    cancelButtonDisabled={isLoading}
                    actionButton={saveOrUpdateBtn}
                />
                <ModalBody>
                    {isLoading && <Spinner text={isCreate ? 'Creating Organization...' : 'Updating Organization...' } />}
                    {!isLoading && < Col className="justify-content-center ">
                        <FormGroup row>
                            <Label
                                for="name"
                                sm={4}
                                className="col-form-label-sm label-md"
                            >
                                Name *
                            </Label>
                            <Col sm={8}>
                                <Input
                                    bsSize="sm"
                                    className=""
                                    id="name"
                                    required
                                    defaultValue={suborgData?.name}
                                />

                            </Col>
                        </FormGroup>

                        {!isCreate &&
                            <FormGroup row>
                                <Label
                                    for="orgId"
                                    sm={4}
                                    className="col-form-label-sm label-md"
                                >
                                    Organization ID
                                </Label>
                                <Col sm={8}>
                                    <Input
                                        bsSize="sm"
                                        id="orgId"
                                        required
                                        defaultValue={suborgData?.accountId}
                                        disabled
                                    />

                                </Col>

                            </FormGroup>
                        }
                        {hasError && <div className="text-center text-danger" role="alert">{errorMessage}</div>}
                    </Col>
                    }
                </ModalBody>
            </PreventEnterSubmitForm>
        </Modal>
    )
}
